import * as classnames from 'classnames'
import * as React from 'react'

import { config } from '../../../common/config'
import * as styles from './trendingSash.module.css'

interface IProps {
  large?: boolean
}

const srcUrl = `${config.assets.PUBLIC_PATH}/images/trending-sash.svg`

const TrendingSash = (props: IProps) => {
  const trendingSashClass = classnames(styles.root, {
    [styles.large]: props.large
  })

  return <img className={trendingSashClass} alt="Trending" src={srcUrl} />
}

export default TrendingSash
